import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/CustomModal/CustomModal';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import { alertService } from '../../services/AlertService';
import UtilityService from '../../services/UtillityServices/UtilityService';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import { ACTION_TYPES } from '../../model/actions';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import useContabilizzazioni from '../../hooks/useContabilizzazioni';
import ContabilizzaManagerForm from '../../components/Forms/ContabilizzaManagerForm/ContabilizzaManagerForm';
import ContabilizzaDetail from '../../components/ContabilizzaDetail/ContabilizzaDetail';
import useGestioneContabilizzazioniConfigTable from '../../configTable/useGestioneContabilizzazioniConfigTable';

const GestioneContabilizzazioniPage = () => {
  const {
    createContabilizzazione,
    loadingStateContabilizzazioni,
    modalStateContabilizzazioni,
    setModalStateContabilizzazioni
  } = useContabilizzazioni();

  const {
    getClassiUtentiByParams,
    loadingStateClassiUtenti,
  } = useClassiUtenti();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [listaDaContabilizzare, setListaDaContabilizzare] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formCreateContabilizzazione, setFormCreateContabilizzazione] = useState({});

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingContabilizzazioni, setIsLoadingContabilizzazioni] = useState(false);
  const contabilizzazioniConfigTable = useGestioneContabilizzazioniConfigTable();

  useEffect(() => {
    if (!isLoadingContabilizzazioni) {
      printAllContabilizzazioni();
    }
  }, [orderBy, orderType, selectedPage]);
  
  const fetchContabilizzazioni = async (obj) => {
    setIsLoadingContabilizzazioni(true);
  
    obj = {
      ...obj,
      filtri: {
        sconto_corsista: 1,
        ...obj.filtri,
      }
    };
  
    const fetchContabilizzazioniList = await getClassiUtentiByParams(obj);
    const countPagination = Math.ceil(fetchContabilizzazioniList?.count / obj.limite);
    let contabilizzazioniList = fetchContabilizzazioniList?.data ?? [];
    setTotalPages(countPagination);
    setListaDaContabilizzare(contabilizzazioniList);
    setIsLoadingContabilizzazioni(false);
    if(contabilizzazioniList?.length === 0){
      setSelectedPage(1)
    }
  }
  
  const printAllContabilizzazioni = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "data_inserimento"} ${orderType ?? "desc"}`
    };
  
    await fetchContabilizzazioni(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
  
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "data_inserimento"} ${orderType ?? "desc"}`
    };
  
    await fetchContabilizzazioni(obj);
  };

  const handleCloseModal = () => {
    setModalStateContabilizzazioni(state => ({ 
       ...state,
       showModalCreateContabilizzazione: false, 
       showModalDetailContabilizzazione: false
      }));
      setSelectedItem(null);
      setFormCreateContabilizzazione({});
  }

  const onCreateContabilizzazione = async () => {
    const requiredFields = ["numero_fattura", "data_fattura"];
    const missingFields = UtilityService.validationForm(formCreateContabilizzazione, requiredFields);
    if (missingFields?.length > 0) {
      const formatFields = missingFields.map(field =>  field.replace("numero_fattura", "Numero fattura").replace("data_fattura", "Data fattura"));
      alertService.warn(`I seguenti campi sono obbligatori: ${formatFields.join(", ")}`, { autoClose: true });
      return;
    }

    let obj = {
      ...formCreateContabilizzazione,
      id_classi_utenti: selectedItem?.id_classe_utente,
      sconto_default_partner: selectedItem?.partner?.sconto_default,
      id_agenzia: selectedItem?.partner?.agenzia?.id_agenzia
    }  
    
    const res = await createContabilizzazione(obj);
      if(res) {
        printAllContabilizzazioni();
      } 
      handleCloseModal();
  };

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const handleContabilizza = (contabilizzazione) => {
    setSelectedItem(contabilizzazione);
    setModalStateContabilizzazioni(state => ({ ...state, showModalCreateContabilizzazione: true }));
  }

  const handleDettaglio = (contabilizzazione) => {
    setSelectedItem(contabilizzazione);
    setModalStateContabilizzazioni(state => ({ ...state, showModalDetailContabilizzazione: true }));
  }

  const actions = [
    {
      label: "Contabilizza",
      icon: 'bi bi-cash-coin text-success',
      tooltip: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: (value) => value.stato_contabilizzazione === "Da_contabilizzare",
      onClick: (contabilizzazione) => handleContabilizza(contabilizzazione)
    },
    {
      label: "Dettaglio",
      icon: 'bi bi-eye text-dark',
      tooltip: ACTION_TYPES.DETAILS,
      type: ACTION_TYPES.MANAGER,
      condition: (value) => value.stato_contabilizzazione === "Contabilizzato",
      onClick: (contabilizzazione) => handleDettaglio(contabilizzazione)
    },
  ];

  return (
    <>
        <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
            <div className='container'>
              <div className='d-flex justify-content-between custom-card-header'>
                <div className='d-flex gap-3 custom-card-title my-2'>
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-receipt fs-2`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='fs-4 d-block'><i><b>Gestione contabilizzazioni</b></i></span>
                  </div>
                </div>
              </div>
              <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateClassiUtenti.isLoadingClassiUtentiByParams}
                  searchNodeType={[
                    {nodeType: "select", name: "stato_contabilizzazione", placeholder: "Stato contabilizzazione"},
                  ]}
                />
              </div>
              {  !loadingStateClassiUtenti.isLoadingClassiUtentiByParams ? ( 
                  <>
             {(!listaDaContabilizzare || listaDaContabilizzare?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono contabilizzazioni da mostrare.</p>
                    </div>) : (
                      <>
              <CustomTable
                  data={listaDaContabilizzare}
                  actions={actions}
                  columns={contabilizzazioniConfigTable}
                  handleOrder={handleOrder}
                  orderBy={orderBy}
                  orderType={orderType}
              />
              <div className="d-flex justify-content-end mt-1">
                <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                />
              </div>
                </>
                    )}
                  </>
              ) : (
                <LoadingTable loadingCol={4} />
              ) }
              <>
              </>
            </div>
        </div>
        <CustomModal
          show={modalStateContabilizzazioni.showModalCreateContabilizzazione}
          onHide={handleCloseModal}
          headerText="Contabilizza"
          size={"md"}
          btnText={"Contabilizza"}
          body={<ContabilizzaManagerForm 
            formContabilizzazioneManager={formCreateContabilizzazione}
            setFormContabilizzazioneManager={setFormCreateContabilizzazione}
            showModalContabilizzazioneManager={modalStateContabilizzazioni.showModalCreateContabilizzazione}
            selectedItem={selectedItem}
          />} 
          isLoading={loadingStateContabilizzazioni.isLoadingContabilizzazioneCreating}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onCreateContabilizzazione} 
        />
        <CustomModal
          show={modalStateContabilizzazioni.showModalDetailContabilizzazione}
          onHide={handleCloseModal}
          headerText="Dettaglio contabilizzazione"
          size={"md"}
          body={<ContabilizzaDetail selectedItem={selectedItem} />}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          showFooter={false}
          hideSaveBtn={true}
        />
      </>
  )

}

export default GestioneContabilizzazioniPage;

